module.exports = __webpack_public_path__ + "static/img/2.4ee77a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/2/2.png
// module id = lbBu
// module chunks = 1